import { render, staticRenderFns } from "./vueVideoClip.vue?vue&type=template&id=5794aa20&scoped=true&"
import script from "./vueVideoClip.vue?vue&type=script&lang=js&"
export * from "./vueVideoClip.vue?vue&type=script&lang=js&"
import style0 from "./vueVideoClip.vue?vue&type=style&index=0&id=5794aa20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5794aa20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\maixun_cxx\\private_library\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5794aa20')) {
      api.createRecord('5794aa20', component.options)
    } else {
      api.reload('5794aa20', component.options)
    }
    module.hot.accept("./vueVideoClip.vue?vue&type=template&id=5794aa20&scoped=true&", function () {
      api.rerender('5794aa20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/vueVideoClip.vue"
export default component.exports